// The brand-independent colors of the corporate theme's design system.

export const alertDefault = "#e39600";
export const alertLight = "#fff3dc";
export const errorDefault = "#cf0300";
export const errorLight = "#fff1f2";
export const error300 = "#fda29b";
export const gray300 = "#d5d7da";
export const neutral100 = "#f6f6f6";
export const neutralBlack = "#000000";
export const neutralBlack25 = "rgba(0, 0, 0, 0.25)";
export const neutralDark = "#727580";
export const neutralDarker = "#3d3e44";
export const neutralDefault = "#989caa";
export const neutralLight = "#B1B5BF";
export const neutralLighter = "#DEDEDE";
export const neutralLightest = "#F6F6F6";
export const neutralWhite = "#ffffff";
export const successDefault = "#007f1e";
export const successLight = "#e9fce5";

export const borderButton = neutralBlack25;
export const borderDefault = neutralLighter;
export const borderError = errorDefault;
export const borderSuccess = successDefault;
export const borderWarning = alertDefault;
export const iconDefault = neutralBlack;
export const surfaceActionDisabled = neutralLight;
export const surfaceAlert = alertLight;
export const surfaceError = errorLight;
export const surfaceReverse = neutralWhite;
export const surfaceSectionNeutralLightest = neutral100;
export const surfaceSuccess = successLight;
export const textAlert = alertDefault;
export const textBody = neutralDarker;
export const textBodySecondary = neutralDark;
export const textBodyTertiary = neutralDefault;
export const textDisabled = neutralLight;
export const textDisabledOnBrand = neutralLighter;
export const textError = errorDefault;
export const textHeadings = neutralBlack;
export const textOnBrand = neutralWhite;
export const textSuccess = successDefault;

export const surfacePrimary = "#000";
export const surfaceSecondary = "#00c2b2";
export const textLinkPrimary = "#000";